document.addEventListener('DOMContentLoaded', function () {
    // scroll to view when scroll-to link is clicked and element exists
    const scrollToLinks = document.querySelectorAll('a.scroll-to')
    scrollToLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            const hash = e.target.hash
            const targetElement = document.querySelector(hash)

            if (targetElement) {
                e.preventDefault()
                const scrollAmount =
                    targetElement.getBoundingClientRect().top +
                    window.scrollY -
                    document.querySelector('.main-header').clientHeight
                window.scrollTo({ top: scrollAmount, behavior: 'smooth' });
                history.pushState({}, "", hash)
            }
        })
    })

    // scrollto onload
    const hash = window.location.hash

    if (hash.length && document.querySelector(hash)) {
        const scrollToElem = document.querySelector(hash)
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'
        }
        const scrollAmount =
            scrollToElem.getBoundingClientRect().top +
            window.scrollY -
            document.querySelector('.main-header').clientHeight
        window.scrollTo({ top: scrollAmount, behavior: 'smooth' })

    }
})
